"use client";

import { FunctionComponent, ReactNode } from "react";
import { Tooltip } from "../tooltip/tooltip";
import { Body, Caption, Icon, Wrapper } from "./label.styles";
import { type InputTextProps } from "../form/input-text/input-text";
import { InfoAlt } from "../icons/info-alt";

export interface LabelProps {
    /**
     * ID of the label.
     */
    id?: InputTextProps["id"];

    /**
     * Label of the label.
     */
    label: InputTextProps["label"] | ReactNode;

    /**
     * Tag of the label.
     */
    as?: "div" | "span";

    /**
     * Will open a tooltip on hover the label. Only applied if `label` isset.
     */
    tooltip?: InputTextProps["tooltip"];

    /**
     * Mark the label as required.
     */
    required?: InputTextProps["required"];

    /**
     * Class name of the label.
     */
    className?: string;
}

export const Label: FunctionComponent<LabelProps> = ({ id, label, as, tooltip, required, className }) => {
    const CustomTag = as || "label";
    const customProps = as ? {} : { htmlFor: id };

    return (
        <Wrapper className={className}>
            <CustomTag {...customProps}>
                <Body>
                    <Caption>{label}</Caption>
                    {tooltip && (
                        <Tooltip text={tooltip}>
                            <Icon>
                                <InfoAlt />
                            </Icon>
                        </Tooltip>
                    )}
                    {required && "*"}
                </Body>
            </CustomTag>
        </Wrapper>
    );
};
